import React from 'react';
import Head from 'next/head';
import { VenueProfileContext } from '../../context';
import { Venues } from '@weddingspot/ws-api-client';
import { FeatureFlagContext } from '@weddingspot/ws-core-components';
import { AnalyticsEvent, logEvent } from '@weddingspot/ws-analytics';

import styles from './Pinterest.module.scss';

const Pinterest = () => {
    const context = React.useContext(VenueProfileContext);
    const { isInitialized, flagEnabled } = React.useContext(FeatureFlagContext);

    const wsVenueProfile = React.useMemo(() => context.wsVenueProfile, []) as Venues.VenueDetails;

    const pinterestClickHandler = () => {
        logEvent(AnalyticsEvent.EVTNM_CLICKED_PINTEREST_PHOTOS, {
            Source: 'venue profile page',
        });
    };

    if (!wsVenueProfile.pinterest_link || !isInitialized || !flagEnabled('pinterest_section_on_venue_profile_pages')) {
        return null;
    }

    return (
        <div className={styles.pinterest} id='media'>
            <h2>Social Media</h2>
            <Head>
                <script async={true} defer={true} src='//assets.pinterest.com/js/pinit.js' />
            </Head>
            <div onClick={pinterestClickHandler}>
                <a data-pin-do='embedUser' data-pin-scale-height='340' data-pin-scale-width='80' href={wsVenueProfile.pinterest_link} />
            </div>
        </div>
    );
};

export default Pinterest;
